<template>
  <div class="snack">
    <h2 class="title">深圳十大著名小吃排行榜</h2>
    <p class="snack-synopsis">小吃是一类在口味上具有特定风格特色的食品的总称。小吃就地取材，能够突出反映当地的物质文化及社会生活风貌，是一个地区不可或缺的重要特色，更是离乡游子们对家乡思念的主要对象。下面和小编一起来看深圳十大著名小吃排行榜，希望有所帮助！</p>
    <div v-for="item in list" :key="item.title">
      <p class="item-title">深圳著名小吃{{ item.title }}</p>
      <p class="item-text">{{ item.text }}</p>
    </div>
  </div>
</template>
<script>
export default {
  data () {
    return {
      list: [
        {
          title: '排名一、蛇口鱼仔档',
          text: '蛇口剧院对面的“鱼仔档”，一对老夫妻经营，只做几道菜，不过味道都很棒，喜欢海鲜的不要放过，就是地方偏僻不大好找，有一次在那里邂逅孙小美，可见此地深受广电的青睐。人均消费25。'
        },
        {
          title: '排名二、潮州牛肉丸',
          text: '深圳华强北华新村正对面马路的“潮州牛肉丸”，又是一段经典的回忆，价廉物美，新鲜非常，潮泰什么的比起它，真的一边凉快去吧。强力推荐牛肉，就是最普通那种，配上他们家独有的沙茶酱料，味道简直了！人均20。'
        },
        {
          title: '排名三、猪肚鸡',
          text: '喜欢吃猪肚的深圳人应该都知道猪肚鸡，但是“李师傅脆肚”的名号最近几年可是越来越响亮，位于华强北来自潮州牛肉店正对面小马路的“李师傅脆肚”，汤头极其鲜美，下饭圣品，小编亲眼目击有一哥们凭借小半锅脆肚汤连干9碗米饭。推荐这家，着实不错。人均40。'
        },
        {
          title: '排名四、蚝',
          text: '蚝门九式吃蚝专门店。位于宝安南路肯德基再往下走一点点就可以看见醒目的招牌，主要是吃蚝，就是生蚝，什么样的都有，主推的是红海湾大蚝，另外有九种不同做法，样样各有各滋味，此外各种打冷鱼类，小炒也都值得一试，推荐招牌冰冻生蚝（熟的），一打12个108元，此处消费略贵，人均70。'
        },
        {
          title: '排名五、华香鹅',
          text: '华强北民间瓦缸煨汤馆边上的小店面“华香鹅”，绝对是城中饕餮第一必须光顾的地方，最正宗的广式烧鹅，叉烧，令人欲罢不能，老板水叔，一个烧味强人，值得一见。人均消费20，好吃还不贵。'
        },
        {
          title: '排名六、乳鸽',
          text: '深圳乳鸽最好吃的在光明农场，光明农场最正宗的是在光明招待所。他家的乳鸽烤得亮亮的，看着就垂涎欲滴，一口咬下去皮脆、肉嫩、汁香，连不容易进味的胸脯肉也很好吃。人均消费91，稍贵，附近有草场可以玩。'
        },
        {
          title: '排名七、海鲜',
          text: '说到海鲜不能不说华城，在深圳吃海鲜没有去过华城的话那么实在是太失败了。华城渔港，鼎鼎有名，位于乐园路上，每天凌晨2点左右都是食客满座，生意好的一塌糊涂，关键还是价廉物美，新鲜实惠，建议喜欢吃海鲜的童鞋千万不要放过这家店！人均40。'
        },
        {
          title: '排名八、贡茶的.招牌奶盖',
          text: '严格来书贡茶不算小吃，但贡茶的招牌奶盖几乎是深圳人无所不知无所不晓，特选鲜奶打成的奶泡加上原味茶，奶味香浓、口感绵密，多层次口感，简直回味无穷，让人欲罢不能。深圳贡茶店很多，大型的商场以及很多地铁站都有，几乎个个火爆，因此仿它的也多，所以要食客们自己认准了，人均消费15，很大众化。强烈推荐这款饮品！'
        },
        {
          title: '排名九、羊肉',
          text: '福田长城大厦6栋宁夏招待所职工食堂：不是老饕绝对找不到的绝好地方，不是深爱羊肉不会寻觅到这样绝好的地方。住在福田是幸福的，因为这里有太多羊肉的踪迹，此间羊肉主打“手抓白条”，百分百宁夏空运羊肉，味鲜柔嫩绝不膻腥，但要记住他们只在饭点对外营业。人均25。'
        },
        {
          title: '排名十、鸡煲',
          text: '深大桂庙新村美旺鸡煲店：桂庙烟雾缭绕4年间，啤酒色盅肉串鸡煲，这是深大美食不可缺少的一部分；而美旺的干锅奇味鸡煲实在让人久久不能忘怀。有人从罗湖驱车回深大吃鸡煲，可见对她的热爱。人均16。'
        }
      ]
    }
  }
}
</script>
<style lang="less" scoped>
p {
  margin: 0;
}
h2 {
  margin: 0;
  font-size: 57.6px;
  font-weight: 700;
  line-height: 100px;
}
.snack {
  padding: 48px;
  .snack-synopsis, .item-text, .item-title{
    color: #333;
    width: 100%;
    font-size: 51.2px;
    line-height: 70.4px;
    float: left;
    padding-bottom: 38.4px;
    text-indent: 2em;
  }
  .item-title {
    font-weight: 800;
  }
}

</style>
